import CircularProgress from '@material-ui/core/CircularProgress';
import moment from 'moment';
import { loadingStyle } from '../theme/style';

import Cookies from 'js-cookie';
import { authAxios } from './AxiosHelper';

import { navigateTo } from '../redux/actions';
import store from '../redux/store';
import { clinicStatus, roleTypes, roles, urls } from './Objects';
import { Storage } from './StorageHelper';

export const parseJwt = (token) => {
  if (!token) {
    return;
  }
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace('-', '+').replace('_', '/');
  return JSON.parse(window.atob(base64));
};

export const redToGreen = (percentage) => {
  if (percentage < 0.5) {
    return `rgb(255,${Math.round(percentage * 2 * 255)},0)`;
  } else {
    return `rgb(${255 - Math.round((percentage - 0.5) * 2 * 255)},255,0)`;
  }
};

export const getComplianceBuckets = (patient) => {
  const ob = {
    duration: 121212,
    activity_type: 2,
    bucket: 'month',
    oldest: '2022-02-13T10:22:00+00:00',
  };
  const goal = patient.complianceHours || 14;
  const compBuckets = {
    week: {
      seconds: 0,
    },
    month: {
      seconds: 0,
    },
    year: {
      seconds: 0,
    },
  };

  try {
    patient.cpab = patient.cpab || [];
    let cpab = patient.cpab;
    console.log('this is cpab: ', cpab, goal);
    if (cpab) {
      cpab.map((c) => {
        if (c && c.activity_type > 0) {
          compBuckets[c.bucket].seconds = compBuckets[c.bucket].seconds + c.duration;
        }
      });
    }

    compBuckets.week.percent = (compBuckets.week.seconds / (goal * 3600 * 7)) * 100;
    compBuckets.month.percent = (compBuckets.month.seconds / (goal * 3600 * 30)) * 100;
    compBuckets.year.percent = (compBuckets.year.seconds / (goal * 3600 * 365)) * 100;

    return compBuckets;
  } catch (error) {
    console.log('Compilance Bucket Error:', error);
  }
  return [];
};

export const getComplianceSeconds = (day, daySeconds) => {
  let seconds = 0;
  const formattedDay = moment(day).format('YYYY-MM-DD');
  try {
    // TODO make this faster
    daySeconds.map((ds) => {
      const formattedDs = ds.day.substring(0, 10);
      if (ds.activity_type && formattedDay === formattedDs) {
        // this a hack, but dates are hard ¯\_(ツ)_/¯
        seconds += parseInt(ds.total_interval, 10);
      }
    });
    return seconds;
  } catch (error) {
    return [];
  }
};

export const fillPatientsBuckets = (patientList) => {
  patientList.forEach((patient) => {
    const buckets = getComplianceBuckets(patient);

    patient.complianceBuckets = buckets;
    patient.weekCompliancePercent = buckets.week.percent;
    patient.monthCompliancePercent = buckets.month.percent;
    patient.yearCompliancePercent = buckets.year.percent;
  });
  return patientList;
};

// export const Loading = () => (
//   <div style={loadingStyle}>
//     <CircularProgress color="primary" />
//   </div>
// );

export const getUserRoles = (userId) => {
  return authAxios
    .get(`/users/${userId}/entity-roles`)
    .then((response) => {
      console.log(response.data);
      return response.data;
    })
    .catch((error) => {
      // Handle the error response
      console.error('Error getUserRoles:', error);
      throw new Error(error);
    });
};

export const setImage = (image) => {
  let path = `images`;
  const formData = new FormData();
  formData.append('file', image);
  const config = {
    headers: {
      'content-type': 'multipart/form-data',
    },
  };
  return authAxios
    .post(path, formData, config)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      throw new Error(error);
    });
};

export const getClinicStatus = (statusNum) => {
  return statusNum === 1 ? clinicStatus.Active : clinicStatus.Inactive;
};

export const grantAdminRole = async (userId) => {
  let path = `users/${userId}/grant-admin`;
  console.log('grantAdminRole starting');
  return authAxios
    .put(path)
    .then((response) => {
      console.log('grantAdminRole done');
      return response.data;
    })
    .catch((error) => {
      console.log('grantAdminRole fail');
      console.log(error);
      console.log(error.message);
      throw new Error(error);
    });
};
export const removeAdminRole = async (userId) => {
  let path = `users/${userId}/remove-admin`;
  console.log('removeAdminRole starting');
  return authAxios
    .put(path)
    .then((response) => {
      console.log('removeAdminRole done');
      return response.data;
    })
    .catch((error) => {
      console.log('removeAdminRole fail');
      console.log(error);
      console.log(error.message);
      throw new Error(error);
    });
};

export const editUserClinicFunc = (user) => {
  console.log(' editUserClinicFunc start');
  console.log(user);
  return authAxios
    .put(`/users/${user.id}`, user)
    .then((response) => {
      console.log(' editUserClinicFunc done');
      console.log(response.data);
    })
    .catch((error) => {
      console.log(' editUserClinicFunc failed: ');
      // Handle the error response
      console.error('Error edit user:', error);
      throw new Error(error);
    });
};

export const getRolesFromToken = () => {
  const user = getUserFromToken();
  let myRoles = user.roles;
  if (!Array.isArray(myRoles)) {
    myRoles = [myRoles];
  }
  return myRoles;
};

export const getUserFromToken = () => {
  const token = Cookies.get('auth');
  const user = parseJwt(token);

  return user;
};

export const isLoggedInis = (entityRole) => {
  const roles = getRolesFromToken();
  return roles.includes(entityRole);
};

export const fromRoleNumToString = (roleNum) => {
  switch (parseInt(roleNum)) {
    case 1:
      return roles.Administrator;
    case 2:
      return roles.HealthCareProvider;
    case 3:
      return roles.Patient;
    case 4:
      return roles.Family;
    default:
      return roleNum;
  }
};

export const convertToRoleStrings = (rolesAr) => {
  let rolesArr = rolesAr;
  if (!Array.isArray(rolesArr)) {
    rolesArr = [rolesArr];
  }
  console.log('convertToRoleStrings' + rolesArr);
  return rolesArr.map((roleNum) => fromRoleNumToString(roleNum));
};

export const isUserClinic = () => {
  const userRoles = getRolesFromToken();
  const isHealthCare = userRoles.includes(roles.HealthCareProvider);
  const user = getUserFromToken();
  console.log(user.roleType == roleTypes.User);
  return user.roleType == roleTypes.User && isHealthCare;
};

export const isAdminClinic = () => {
  const userRoles = getRolesFromToken();
  const isHealthCare = userRoles.includes(roles.HealthCareProvider);
  const user = getUserFromToken();
  return user.roleType == roleTypes.Administrator && isHealthCare;
};

export const cleanStorage = () => {
  Cookies.remove('auth');
  Cookies.remove('refreshToken');
  Cookies.remove('clinicName');
  Cookies.remove('clinicId');
  Storage.clean();
};

export const getClinicByUserId = (userId) => {
  let path = `clinics/user/${userId}`;
  return authAxios
    .get(path)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.log(error);
      // handleErrorResponse(error, dispatch);
    });
};

export const isClinics = () => {
  return window.location.toString().includes(urls.clinics);
};
export const isUsers = () => {
  return window.location.toString().includes(urls.users) || window.location.toString().includes(urls.clinicUsers);
};
export const isClinicUsers = () => {
  return window.location.toString().includes(urls.clinicUsers);
};
export const isClinicPatients = () => {
  return window.location.toString().includes(urls.clinicPatients);
};
export const isAdmins = () => {
  return window.location.toString().includes(urls.admins);
};

export const isPaitents = () => {
  return window.location.toString().includes(urls.patients) || window.location.toString().includes(urls.clinicPatients);
};
export const isNonPaitentsClinic = () => {
  return window.location.toString().includes(urls.nonClinicPaitents);
};
export const getCurrPath = () => {
  return window.location.toString();
};

export const getList = () => {
  let items = [];
  const clinic = store.getState().clinic;
  console.log(clinic);

  if (isPaitents() || isNonPaitentsClinic()) return clinic.patientsList;
  if (isUsers() || isAdmins()) return clinic.usersClinic;
  if (isClinics()) return clinic.clinicList;
  return items;
};

export const getNextPage = () => {
  let nextPage = '/';

  if (isPaitents() || isNonPaitentsClinic()) return urls.patientDetails;
  if (isUsers() || isAdmins()) return urls.userDetails;
  if (isClinics()) return urls.clinicDetails;

  return nextPage;
};

export const statusTypes = {
  0: 'InActive',
  1: 'Active',
  2: 'Brace treatment successful',
  3: 'Brace treatment unsuccessful',
  4: 'Patient is moving to a different brace',
  5: 'Patient has been lost to follow up',
  6: 'procceed to surgery',
};

export const getStatusList = () => {
  const numLim = isUsers() || isClinics() || isAdmins() ? 2 : isPaitents() ? 6 : 0;
  return Object.keys(statusTypes)
    .map((key, index) => ({
      id: key,
      name: statusTypes[key],
    }))
    .slice(0, numLim);
};

export const getTimeFrameList = () => {
  return [
    {
      id: 'week',
      name: 'this week',
    },
    {
      id: 'month',
      name: 'this month',
    },
    {
      id: 'year',
      name: 'this year',
    },
  ];
};

export const navigate = (e, pathname, state = null) => {
  e.preventDefault();
  store.dispatch(navigateTo(pathname, state));
};

export const fromByteArrToImage = (byteArray) => {
  const blob = new Blob([byteArray], { type: 'image/jpeg' });

  // Create a URL for the Blob object
  const imageUrl = URL.createObjectURL(blob);
  return imageUrl;
};
export const fromByteArrToBase64 = (byteArray) => {
  let buffer = Buffer.from(byteArray);
  let base64String = buffer.toString('base64');
  return base64String;
};

export const getImage = (imageId) => {
  let path = `images/${imageId}`;
  return authAxios
    .get(path)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      throw new Error(error);
      // console.log(error);
    });
};
